import { useTranslation } from "react-i18next";

const TextAreaForm: React.FunctionComponent<{ height: string, ChangeTextarea: any, value: any }> = (props) => {

    const { t } = useTranslation();

    const HandleChangeAgency = (event: any) => {
        props.ChangeTextarea(event.target.value);
    }

    const countWordsAndCharacters = (value: string) => {
        const charCount = (value ? value.length : 0);
        return charCount;
    }

    return (
        <>
            <textarea className="para-14 bold-500 color-06 textarea back-trans border-trans line-height-25"
                dir="auto" rows={4}
                placeholder={t("report.typeYourSummaryHere")}
                cols={40} style={{ height: `${props.height}`, width: "100%" }}
                value={props.value} onChange={HandleChangeAgency}
                maxLength={700}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === '\n') {
                        e.preventDefault();
                    }
                }}>
            </textarea>
            <div className="character-counter">
                {countWordsAndCharacters(props.value)}/700
            </div>
        </>
    )
}

export default TextAreaForm;